import HttpClient from "api/index";
import {TSpecialtyClusterFilter} from "api/filterOptionsApi/SpecialityApi/types";
import {STPaginationParam} from "api/types";

class MapxSpecialityApi extends HttpClient {
	async getSpecialities(pageNumber: number, config = {}) {
		return this.doGet(`/mapx/specialties?page=${pageNumber}&per_page=40`, config);
	}

	async searchSpecialities(queryParam: string, pageNumber: number, config = {}) {
		return this.doGet(`/mapx/specialties${queryParam}&page=${pageNumber}&per_page=40`, config);
	}

	// async getClusterSpecialities(pageNumber: number, config = {}) {
	// 	return this.doGet(`/specialty-clusters?page=${pageNumber}&per_page=40`, config);
	// }

	async searchClusterSpecialities(queryParam: string | null, pageNumber: number, config = {}) {
		return this.doGet(
			`/specialty-clusters${queryParam}&page=${pageNumber}&per_page=40`,
			config,
		);
	}

	async getClusterSpecialities(pagination: STPaginationParam, config = {}) {
		return this.doPost(`/get-specialty-clusters`, {pagination}, config);
	}

	async getFilteredClusterSpecialities(
		filters: TSpecialtyClusterFilter,
		pagination: STPaginationParam,
		config = {},
	) {
		const payload = {
			filters,
			pagination,
		};

		return this.doPost(`/get-specialty-clusters`, payload, config);
	}
}

const mapxSpecialityApi = new MapxSpecialityApi();

export default mapxSpecialityApi;
